import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import { LoadRegistrastionJournyData } from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';

function fetchVariationChildService(token,data) {
    console.log(token)
    return axios.post(`${CURRENT_API_URL}/amazonProductListing/fetchVariationChild`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        // notify.NotifySuccess("Your weekly recipient updated successfully!");
        return res.data;
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching child products. please try again later.");
        return false;
    });
}


export default fetchVariationChildService;